import { getCategoryNavigationTree } from "@electricMotorShop/Services/CategoryService";
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";

import  { chain,DispatchCompleteLoad,PopulateRootId, RequestDataFromApi } from "@insite/client-framework/Store/Data/NavigationTree/Handlers/LoadNavigationTree";

type loadNavigationTreeProps = Parameters<typeof PopulateRootId>[0];

async function CustomRequestDataFromApi(props: loadNavigationTreeProps)  {
    try {
        props.apiResult = await getCategoryNavigationTree(props.apiParameter);
    } catch (error) {
        if (error?.status === 404 || error?.status === 403) {
            props.dispatch({
                type: "Data/NavigationTree/FailedToLoad",
                rootId: props.rootId,
                status: error.status,
            });
            return false;
        }
        throw error;
    }
}

function CustomDispatchCompleteLoad(props: loadNavigationTreeProps) {
    props.dispatch({
        type: "Data/NavigationTree/CompleteLoad",
        result: props.apiResult,
    });
};


replaceInChain(
    chain,
    RequestDataFromApi,
    CustomRequestDataFromApi
);

replaceInChain(
    chain,
    DispatchCompleteLoad,
    CustomDispatchCompleteLoad
);